<template>
  <div>
    <div class="padding">
        <div class="text-gray">最多设置{{maxCount}}个标签，总字数不能超过40个字符。</div>

        <van-cell-group class="margin-top">
            <van-field v-for="(item, index) in tags" v-model="tags[index]" :placeholder="`标签${index + 1}`" :key="index" maxlength="20" />
        </van-cell-group>

        <div class="text-center margin-tb">
            <van-button type="primary" size="large" @click="submit">保存</van-button>
        </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import { Cell, CellGroup, Button, Toast, Dialog, Field, Icon } from 'vant';
  import { getClerk, updateTags } from '@/api/clerk/clerk'

  Vue.use(Cell)
        .use(CellGroup)
        .use(Button)
        .use(Toast)
        .use(Dialog)
        .use(Field)
        .use(Icon)

  export default {
    name: 'updateTags',
    data () {
      return {
        tags: [],
        maxCount: 6
      }
    },
    methods: {
      loadData() {
        Toast.loading({
          mask: true,
          message: '加载中...'
        })
        getClerk().then(res => {
          Toast.clear()
          const data = res.data
          if (data.code == 0) {
            let tags = data.clerk.tags
            for (let i = 0; i < tags.length; i++) {
              this.$set(this.tags, i, tags[i])
            }
          } else {
            Dialog.alert({
              title: '加载失败',
              message: data.msg
            })
          }
        })
      },
      submit() {
        Toast.loading({
          mask: true,
          message: '请稍候...'
        })

        let tagList = []
        let wordCount = 0
        for (const tag of this.tags) {
          if (tag != null && tag.trim() != '') {
            tagList.push(tag.trim())
            wordCount += tag.length
          }
        }

        if (wordCount > 40) {
            return Toast('标签总字数不能超过40个字');
        }

        updateTags(JSON.stringify(tagList)).then(res => {
          Toast.clear()
          const data = res.data;
          if (data.code == 0) {
            Dialog.alert({
              title: '提交成功'
            }).then(()=>{
              this.$router.back(-1)
            })
          } else {
            this.loadData()
            Dialog.alert({
              title: '修改失败',
              message: data.msg
            })
          }
        })
      }
    },
    mounted() {
      for (let i = 0; i < this.maxCount; i++) {
        this.tags.push(null)
      }
      this.loadData()
    }
  }
</script>

<style lang="less" scoped>


</style>
